/** @format */

import {Box, Button} from '@mui/material';
import {styled} from '@mui/material/styles';

export const InfoBanner = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.semantic_light?.primary.container,
  borderRadius: '16px',
  padding: '8px',
  fontSize: '14px',
  lineHeight: '16px',
  color: theme.palette.semantic_light?.primary.onContainer,
}));

export const LightTabsContainer = styled(Box)(() => ({
  display: 'inline-flex',
  borderRadius: '8px',
  overflow: 'hidden',
  gap: '1px',
}));

export const LightTab = styled(Button, {
  shouldForwardProp: prop => prop !== 'isActive' && prop !== 'compact',
})<{isActive?: boolean; compact?: boolean}>(({theme, isActive, compact}) => ({
  padding: compact ? '8px' : '16px',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  textTransform: 'none',
  borderRadius: 0,
  minWidth: 'auto',
  gap: '8px',
  backgroundColor: isActive
    ? theme.palette.semantic_light?.primary.main
    : theme.palette.semantic_light?.surface.surface1,
  color: isActive
    ? theme.palette.semantic_light?.primary.on
    : theme.palette.semantic_light?.surface.onSurfaceLight,
  '&:hover': {
    backgroundColor: isActive
      ? theme.palette.semantic_light?.primary.hover
      : theme.palette.semantic_light?.surface.surface2,
  },
}));
